import { useState, useEffect } from "react";
import { Link as RouterLink, useParams, useNavigate } from "react-router-dom";
import { Avatar, Box, Button, ButtonGroup, Container, Grid, Stack, Typography, TextField, Chip, Checkbox, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Select, OutlinedInput, MenuItem, useTheme, FormControl, FormControlLabel, FormLabel, RadioGroup, Radio, Paper, Autocomplete, Tabs, Tab } from "@mui/material";
// components
import Page from "src/components/Page";
import moment from "moment";
import { alert } from "src/services/alert";
import FormItem from "src/components/form-item/FormItem";
import { useSelector } from "react-redux";
import FormDialog from "src/components/common/FormDialog";
import NavBack from "src/components/common/NavBack";
import { asyncRequest } from "src/services/network";
import UserPicker from "src/components/common/UserPicker";
import { IMG_BASE_URL } from "src/config/constants";
import { Switch } from "@mui/material";
import MyEditor from "src/components/editor/MyEditor";
// ----------------------------------------------------------------------

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function AgreementList() {
  const navigate = useNavigate();

  const [agreementMap, setAgreementMap] = useState({});
  const [tab, setTab] = useState(0);
  const [items, setItems] = useState([]);

  const [detail, setDetail] = useState(null);

  // console.log(agreementMap);

  useEffect(() => {
    getAgreementMap();
  }, []);

  useEffect(() => {
    if (!items.length) return;
    setDetail(items[tab].value);
  }, [tab]);

  async function getAgreementMap() {
    const { data } = await asyncRequest({
      method: "get",
      path: `/setting/agreement`,
    });

    setItems(data);
    setDetail(data[tab].value);
  }

  function handleTabChange(e, val) {
    console.log(e, val);
    setTab(val);
  }

  async function handleSubmit() {
    console.log(tab);
    // if (!items.length) return;
    const ki = items[tab].key;
    const { msg } = await asyncRequest({
      path: `/setting/agreement/edit`,
      data: {
        ki,
        val: detail,
      },
    });

    alert(msg, "success");
    getAgreementMap();
  }

  return (
    <Page title="协议管理">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <NavBack title="协议管理"></NavBack>
        </Stack>

        <Paper variant="outlined" sx={{ py: 1, pr: 3 }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={tab} onChange={handleTabChange}>
              {items.map((item) => (
                <Tab label={item.name} key={item.key} />
              ))}
            </Tabs>
          </Box>

          <TabPanel>
            <MyEditor
              html={detail}
              onChange={(val) => {
                // console.log(val, items.length);
                setDetail(val);
              }}
            />

            <Button variant="contained" type="submit" onClick={handleSubmit}>
              保存
            </Button>
          </TabPanel>
          {/* <TabPanel value={tab} index={1}></TabPanel> */}
        </Paper>
      </Container>
    </Page>
  );
}
